// Design tokens for the FoodMenuBuilder redesign
export const MENU_BUILDER_TOKENS = {
  colors: {
    sidebarBg: '#0F1B2D',
    sidebarText: '#FFFFFF',
    sidebarMuted: 'rgba(255, 255, 255, 0.55)',
    sidebarActiveRow: '#0D3B66',
    sidebarActiveBadge: 'rgba(255,255,255,0.25)',
    sidebarInactiveBadge: 'rgba(255,255,255,0.15)',
    primaryBlue: '#0D3B66',
    primaryBlueLight: '#E8F0F8',
    chipSelected: '#0D3B66',
    chipUnselected: 'transparent',
    chipUnselectedBorder: '#E2E8F0',
    chipUnselectedBg: '#F8FAFC',
    panelBg: '#FFFFFF',
    contentBg: '#FFFFFF',
    textPrimary: '#1E293B',
    textSecondary: '#64748B',
    textMuted: '#94A3B8',
    bulletDot: '#0D3B66',
    divider: '#E2E8F0',
    cardBorder: '#E2E8F0',
    cardBg: '#FFFFFF',
    subcategoryBorder: '#0D3B66',
  },
  spacing: {
    panelPadding: 2.5,
    sectionGap: 3,
    chipGap: 1.25,
    categoryRowPy: 1,
    categoryRowPx: 1.5,
  },
  borderRadius: {
    panel: '16px',
    chip: '24px',
    badge: '12px',
    categoryRow: '24px',
    card: '12px',
  },
  typography: {
    uppercaseLabel: {
      fontSize: '11px',
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase' as const,
    },
    heading: {
      fontSize: '26px',
      fontWeight: 700,
    },
    body: {
      fontSize: '14px',
      fontWeight: 400,
    },
    bodyLarge: {
      fontSize: '16px',
      fontWeight: 500,
    },
    caption: {
      fontSize: '12px',
      fontWeight: 500,
    },
  },
  layout: {
    categoryPanelWidth: { sm: 2.5 },
    itemGridWidth: { sm: 5.5 },
    summaryPanelWidth: { sm: 4 },
  },
} as const;
